import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
  function (config) {

    const jwt = localStorage.getItem("porteltoken");


    // Set the authentication token header
    config.headers["x-auth-token"] = jwt;

    // Set the custom domain header
    config.headers["X-Custom-Domain"] = window.location.hostname;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(null, (error) => {
  if (error?.response?.status === 401) {
    if (window.location.pathname === "/login") {
      return;
    }

    localStorage.removeItem("porteltoken");
    localStorage.removeItem("activeProject");
    window.location.replace(
      `/login?reason=${error?.response?.message ?? "Session expired. Please login again!"}`,
    );
  }

  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
};
